import React from "react";

export default function MiniCalendarSkeleton({ isDarkMode }: { isDarkMode: boolean }) {
  const row = (key: string) => (
    <div key={key} className={`p-3 rounded-md border ${isDarkMode ? "border-gray-700 bg-gray-700/60" : "border-gray-200 bg-gray-100"}`}>
      <div className={`h-4 w-20 mb-2 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-300"}`} />
      <div className={`h-3 w-38 mb-1 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-300"}`} />
      <div className={`h-3 w-32 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-300"}`} />
    </div>
  );

  return (
    <div>
      <div className="flex items-center gap-3 mb-4 pb-3 border-b border-transparent">
        <div className={`h-7 w-40 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
        <div className={`h-7 w-40 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
      </div>
      <div className="grid grid-cols-2 gap-3 mb-4">
        {Array.from({ length: 6 }).map((_, i) => row(String(i)))}
      </div>
      <div className="flex items-center justify-between pt-3">
        <div className={`h-8 w-32 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
        <div className={`h-3 w-40 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"}`} />
      </div>
    </div>
  );
}
